<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <div>
          <mdb-input
            id="searchInput"
            class="autocomplete"
            type="text"
            placeholder="Search"
            :value="search"
            v-model="search"
            @input="onChange"
            @click="isOpen = true"
          />
          <ul v-show="isOpen" class="autocomplete-results-list model">
            <li
              id="searchList"
              v-for="(result, i) in results"
              :key="i"
              @click="onSelect(result)"
              class="autocomplete-result"
            >
              {{ result }}
            </li>
          </ul>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { mdbInput } from "mdbvue";
export default {
  name: "DtAutoComplete",
  components: {
    mdbInput
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      search: "",
      results: this.items,
      isOpen: false
    };
  },
  created() {
    window.addEventListener("click", this.onClickOutsideme);
  },

  destroyed() {
    window.removeEventListener("click", this.onClickOutsideme);
  },
  methods: {
    onChange() {
      this.isOpen = true;
      this.filterResults();
      if (this.search == "") {
        this.$emit("cleared");
      }
    },
    filterResults() {
      this.results = this.items.filter(
        item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    },
    onSelect(selectedItem) {
      this.isOpen = false;
      this.search = selectedItem;
      this.$emit("selected", this.search);
    },
    onClickOutsideme(event) {
      if (!["searchInput", "searchList"].includes(event.target.id)) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.model {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 990000;
}
.autocomplete {
  position: relative;
  width: 100%;
  margin-bottom: 0%;
  outline: none;
}
div.autocomplete {
  width: 100%;
  input.form-control {
    border: 1px solid #cfdce5 !important;
    border-radius: 5px !important;
    padding: 5px;
    width: 100%;
    margin: 40px auto;
  }
}
.autocomplete-results-list {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee94;
  border-top: 0px;
  height: auto;
  max-height: 300px;
  width: 100%;
  // margin: -40px 0 0 40%;
  overflow: scroll;
  background-color: rgb(255, 255, 255);
  opacity: 0.9;
  left: 15px;
  top: 76px;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
  opacity: 1;
  color: black;
  &:hover {
    background-color: #5586ab;
    color: white;
  }
}
</style>
